import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const CHARACTERS_IEAM = [
  {
    title: "NETWORK SERVICE\n PROVIDER",
    subtitle: "Eg. Private 5G network provider",
    items: [
      "Provide platforms for both\n customers and application\n vendors",
      "Efficiently monetize the\n network services",
      "Agile practices for\n application management",
    ],
    image: "ENG/characters/character_1.gif",
    next: {
      label: "PROVIDER DEMO",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_105");
      },
      endIcon: "play",
    },
  },
  {
    title: "ENTERPRISE\n EXECUTIVE",
    subtitle: "Eg. Car manufacturer",
    items: [
      "Secure and reliable 5G\n services",
      "Self-service and\n management",
      "Access to the application\n marketplace",
    ],
    image: "ENG/characters/character_2.gif",
    next: {
      label: "ENTERPRISE DEMO",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_111");
      },
      endIcon: "play",
    },
  },
  {
    title: "USE CASE\n PROVIDER",
    subtitle: "Eg. Drone services",
    items: [
      "Platform to certify and\n publish services",
      "In-built monetisation\n facilities for speed-to-\n market",
      "Innovative 5G network\n capabilities",
    ],
    image: "ENG/characters/character_3.png",
    gif: "ENG/characters/character_3.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
    next: {
      label: "AI ASSISTED DEMO",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_116");
      },
      endIcon: "play",
    },
  },
];

export const DATA_CHARACTERS_IEAM = {
  title: "Challenges solved",
  bgImage: "ENG/IEAM/IEAM_Introduction_01.png",
  characters: CHARACTERS_IEAM,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_103"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  actions: [
    {
      label: "Provider Demo",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_105");
      },
      endIcon: "play",
    },
    {
      label: "Enterprise Demo",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_111");
      },
      endIcon: "play",
    },
    {
      label: "AI Assisted Demo",
      onClick: () => {
        setPreviousPage("ENG_104");
        setCurrentPage("ENG_116");
      },
      endIcon: "play",
    },
  ],
  modalImages: ["ENG/IEAM/modal/IEAM_MODAL_characters_1.png"],
  modalContentCustomStyle: { paddingTop: "48px" },
};
